<template>
    <div style="width: 100%; text-align: right;">
        <fe-tooltip :tooltip="params.tooltipText">
            <span style="font-size: 14px; margin-right: 5px;">{{ params.displayName }}</span>
            <v-icon color="#495B8F">{{ params.iconClass }}</v-icon>
        </fe-tooltip>
    </div>
</template>

<script>

export default {
    name: 'IconHeader'
}
</script>

<style lang="scss" scoped>
</style>
